// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'e2eAttributeEncoding',
    standalone: false,
})
export class E2eAttributeEncodingPipe implements PipeTransform {
    transform (input: unknown): string {
        if (!input || typeof input !== 'string') {
            return input as string;
        }
        return encodeURIComponent(input).toLowerCase();
    }
}
